import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import MedCard from './MedCard';

const PatientCard = ({ patient }) => {
    const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
    let facilityObj = facilityList.reduce((obj, item) => {
        obj[item.value] = item.key;
        return obj;
    }, {});

    const isHospice = patient?.orders?.some(order => Number(order.order_type) === 7);
    const highlight = patient.orders?.some(order => Number(order.created_by_role_id) < 4);
    const isDeliveryTypeOne = patient.orders?.some(
        order => order.delivery_type === 1
    );
    const isDeliveryTypeFive = patient.orders?.some(
        order => order.delivery_type === 5
    );

    function getEarliestDeliveryDate(patient) {
        const dates = patient.orders
            .map(order => order.delivery_date)
            .filter(Boolean)
            .map(date => new Date(date));

        if (dates.length === 0) return null;

        const earliest = new Date(Math.min(...dates));
        const mm = String(earliest.getMonth() + 1).padStart(2, '0');
        const dd = String(earliest.getDate()).padStart(2, '0');
        const yy = String(earliest.getFullYear()).slice(-2);

        return `${mm}/${dd}/${yy}`;
    }

    return (
        <Card
            className={`cycleViewCard m-2 ${highlight ? "highlight-card" : ""}`}
            role="button"
        >
            {/* {isHospice && <div className="hospice-flag">
                ⚕️ HOSPICE
            </div>} */}
            {/* <Card.Header className={
                `${isDeliveryTypeOne ? "bg-red" : isDeliveryTypeFive ? "bg-brown" : "bg-orange"} 
            px-3 py-1 text-white`
            }>
                {patient.patient_lastname},{patient?.patient_firstname}
            </Card.Header> */}

            <Card.Header
                className={`${isDeliveryTypeOne ? "bg-red" : isDeliveryTypeFive ? "bg-brown" : "bg-orange"} px-3 py-1 text-white d-flex align-items-center justify-content-between`}>
                <span className="patient-name">
                    {patient.patient_lastname},{patient?.patient_firstname}
                </span>

                {isHospice && (
                    <span className="hospice-pill">
                        ⚕️ HOSPICE
                    </span>
                )}
            </Card.Header>


            {/* <Card.Body className={"bg-orange-body text-dark px-2 py-1"}> */}
            <Card.Body className={
                `${isDeliveryTypeOne ? "bg-red-body" : isDeliveryTypeFive ? "bg-brown-body" : "bg-orange-body"} 
   text-dark px-2 py-1`
            }>

                <Row>
                    <Col xs="7">
                        <span>{facilityObj[patient.facility_id]}</span>
                    </Col>
                    <Col xs="5" className="text-end">
                        {getEarliestDeliveryDate(patient)}
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        {patient?.orders?.map((order, i) => (
                            <div
                                key={i}
                                className="position-relative mb-1 rounded-2 bg-white shadow-sm"
                            >
                                {(order?.internal_notes?.length > 0) && (
                                    <div className="position-absolute top-0 bottom-0 start-0 bg-success"
                                        style={{ width: 6, borderTopLeftRadius: 'inherit', borderBottomLeftRadius: 'inherit' }}
                                    />
                                )}
                                {(order?.notes?.length > 0) && (
                                    <div className="position-absolute top-0 bottom-0 end-0 bg-info-dark"
                                        style={{ width: 6, borderTopRightRadius: 'inherit', borderBottomRightRadius: 'inherit' }}
                                    />
                                )}
                                <div className="px-3 py-0">
                                    <MedCard data={order} />
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default PatientCard;
